export default __webpack_public_path__ + "static/media/2018-IMcover.f3897e1d.jpg";